function RecommendationTracker(analytics) {

    this.analytics = analytics;
    this.$items = $('.carousel__item a');
    this.$carouselControl = $('.carousel__control');
}

RecommendationTracker.prototype = {
    init() {
        'use strict';

        if (!this.$items.length) {
            return this;
        }

        this.initItemTracking()
            .initScrollTracking();
    },

    /**
     * @return {RecommendationTracker}
     */
    initItemTracking() {
        this.$items.on('click', $.proxy(this.trackItemClick, this));
        return this;
    },

    /**
     * @return {RecommendationTracker}
     */
    initScrollTracking() {
        this.$carouselControl.on('click', $.proxy(this.trackScroll, this));
        return this;
    },

    /**
     * @return {RecommendationTracker}
     */
    trackScroll() {
        this.analytics.track('Recommendation', 'Scroll');
        return this;
    },

    /**
     * @param  {Object} event
     * @return {RecommendationTracker}
     */
    trackItemClick(event) {
        event.preventDefault();
        var $a = $(event.currentTarget),
            manufactuer = $.trim($a.find('.recommendation__manufactuer').text()),
            dimension = $.trim($a.find('.recommendation__dimension').text());



        this.analytics.trackWithCallback(
            {
                eventName: 'Recommendation',
                eventBody: {
                    event_category: 'Selection',
                    event_label: manufactuer + ' ' + dimension
                }
            },
            this.redirect.bind(this, $a.attr('href'))
        );

        return this;
    },

    /**
     * @param  {String} url
     */
    redirect(url) {
        window.location = url;
    }
};

export default RecommendationTracker;